"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var monitoring_1 = require("../../services/monitoring");
var classNames = require("classnames");
var PaginationControl = /** @class */ (function (_super) {
    __extends(PaginationControl, _super);
    function PaginationControl(props) {
        var _this = _super.call(this, props) || this;
        _this.generatePageLinks = function (numberOfPages) {
            var _a = _this.props, goToPageCallback = _a.goToPageCallback, currentPageIndex = _a.currentPageIndex;
            var PageLinks = [];
            var _loop_1 = function (index) {
                var pageLinkClasses = classNames('pagination-control__link', 'pagination-page', { 'pagination-page--current': index === currentPageIndex });
                var PageLink = (React.createElement("li", { key: "pageLink" + index, className: pageLinkClasses }, index === currentPageIndex ? (React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    } },
                    React.createElement("div", { className: "pagination-control__link-active-indicator" }),
                    React.createElement("span", { className: "pagination-control__link-style--active" }, index + 1))) : (React.createElement("a", { className: "pagination-control__link-style", onClick: function () {
                        goToPageCallback(index);
                    } }, index + 1))));
                // Limit the number of page links displayed
                if (numberOfPages > _this.props.numberOfLinksToDisplay) {
                    // Define link gap element
                    var LinkGap = (React.createElement("li", { key: "pageLinkGap" + index, className: "pagination-control__link-gap pagination-page" }, "..."));
                    // Calculate the middle index of the middle pages
                    var linksToDisplay = _this.props.numberOfLinksToDisplay - 2;
                    var middleIndex = currentPageIndex;
                    if (currentPageIndex < Math.ceil(linksToDisplay / 2)) {
                        middleIndex = Math.ceil(linksToDisplay / 2);
                    }
                    else if (currentPageIndex >
                        numberOfPages - 1 - Math.ceil(linksToDisplay / 2)) {
                        middleIndex = numberOfPages - 1 - Math.ceil(linksToDisplay / 2);
                    }
                    // Always add the first page link
                    if (index === 0) {
                        PageLinks.push(PageLink);
                    }
                    else if (index === 1) {
                        // Add link gap if we're far enough from 1 or the second link
                        if (currentPageIndex >= Math.ceil(linksToDisplay / 2) + 1) {
                            PageLinks.push(LinkGap);
                        }
                        else {
                            PageLinks.push(PageLink);
                        }
                    }
                    else if (
                    // Add all the middle links
                    middleIndex - Math.floor(linksToDisplay / 2) <= index &&
                        index <= middleIndex + Math.floor(linksToDisplay / 2)) {
                        PageLinks.push(PageLink);
                    }
                    else if (
                    // If we're on the second to last index
                    index ===
                        numberOfPages - 2) {
                        // Add link gap if we're far enough from the end or the second to last link
                        if (currentPageIndex <=
                            numberOfPages - 1 - Math.ceil(linksToDisplay / 2)) {
                            PageLinks.push(LinkGap);
                        }
                        else {
                            PageLinks.push(PageLink);
                        }
                    }
                    else if (index === numberOfPages - 1) {
                        // Add the last page link
                        PageLinks.push(PageLink);
                    }
                }
                else {
                    PageLinks.push(PageLink);
                }
            };
            for (var index = 0; index < numberOfPages; index++) {
                _loop_1(index);
            }
            return PageLinks;
        };
        return _this;
    }
    PaginationControl.prototype.componentDidMount = function () {
        monitoring_1.default('paginationControl');
    };
    PaginationControl.prototype.render = function () {
        var _a = this.props, goToPageCallback = _a.goToPageCallback, currentPageIndex = _a.currentPageIndex, numberOfPages = _a.numberOfPages, className = _a.className, style = _a.style;
        var classes = classNames('pagination-control', className);
        var previousLinkClasses = classNames('pagination-control__link', 'pagination-control__previous', { 'pagination-control--disabled': currentPageIndex === 0 });
        var nextLinkClasses = classNames('pagination-control__link', 'pagination-control__next', {
            'pagination-control--disabled': currentPageIndex === numberOfPages - 1
        });
        return (React.createElement("nav", { className: classes, style: style },
            React.createElement("ul", { className: "pagination-control__link-list" },
                React.createElement("li", { className: previousLinkClasses }, currentPageIndex === 0 ? (React.createElement("a", { className: "pagination-control__link-style", style: { cursor: 'default' } }, "Previous")) : (React.createElement("a", { className: "pagination-control__link-style", onClick: function () {
                        goToPageCallback(Math.max(0, currentPageIndex - 1));
                    } }, "Previous"))),
                React.createElement("li", { className: "pagination-control__link-list" },
                    React.createElement("ol", { className: "pagination-control__number-links" }, this.generatePageLinks(numberOfPages))),
                React.createElement("li", { className: nextLinkClasses }, currentPageIndex === numberOfPages - 1 ? (React.createElement("a", { className: "pagination-control__link-style", style: { cursor: 'default' } }, "Next")) : (React.createElement("a", { className: "pagination-control__link-style", onClick: function () {
                        goToPageCallback(Math.min(numberOfPages - 1, currentPageIndex + 1));
                    } }, "Next"))))));
    };
    PaginationControl.defaultProps = {
        numberOfLinksToDisplay: 7
    };
    return PaginationControl;
}(React.Component));
exports.default = PaginationControl;
//# sourceMappingURL=PaginationControl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/PaginationControl/PaginationControl.js
// module id = 284
// module chunks = 0